import React, { Fragment, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Trans } from 'react-i18next';
import { getClientDownloadLink, getSupportedBrowsersList } from '@low/index';
import { copyToClipboard } from '@ringcentral/rwc-utils/src/copy-to-clipboard';
import { meetingId } from '@low/guard';

const SupportedBrowserList = ({ browserListDataAtItem }) => {
    const browsersList = getSupportedBrowsersList();
    /* eslint-disable no-nested-ternary */
    return browsersList.map((browser, i) => (
        <Fragment key={browser}>
            <a
                href={getClientDownloadLink(browser)}
                data-at={browserListDataAtItem && `${browserListDataAtItem}::${browser}`}>
                {i18n.t(`BROWSERS.${browser}`)}
            </a>
            {i < browsersList.length - 2 ? (
                ', '
            ) : i < browsersList.length - 1 ? (
                <Fragment>&nbsp;{i18n.t('global.OR')}&nbsp;</Fragment>
            ) : null}
        </Fragment>
    ));
    /* eslint-enable no-nested-ternary */
};

SupportedBrowserList.propTypes = {
    browserListDataAtItem: PropTypes.string,
};

export const UnsupportedJoinSteps = ({
    trackCopyMeetingEvent,
    onSuccessCopyLink,
    browserListDataAtItem,
    copyButtonDataAt = '',
}) => {
    const meetingURL = useMemo(
        () =>
            !meetingId ? location.origin : `${location.origin}/join/${meetingId}${location.search}`,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [meetingId, location]
    );

    const copyOnEnter = e => {
        if (e.key === 'Enter') {
            onCopyMeetingLink();
        }
    };

    const onCopyMeetingLink = useCallback(() => {
        trackCopyMeetingEvent?.();
        copyToClipboard(meetingURL).then(() => onSuccessCopyLink?.());
    }, [meetingURL, trackCopyMeetingEvent, onSuccessCopyLink]);

    return (
        <div className='join-steps-wrapper'>
            <h3 className='welcome-text'>
                {i18n.t('DOWNLOAD.web_join_steps.browser_unsupported_reason')}
            </h3>
            <div className='step'>
                {i18n.t('DOWNLOAD.web_join_steps.to_join_unsupported_browser')}
            </div>
            <div className='step'>
                <div className='step-order'>1</div>

                <div className='step-content'>
                    <div className='copy-link-wrapper'>
                        <div className='link'>
                            <span>{meetingURL}</span>
                        </div>
                        <button
                            type='button'
                            className='copy-button'
                            onKeyDown={copyOnEnter}
                            data-at={copyButtonDataAt}
                            onClick={onCopyMeetingLink}>
                            {i18n.t('DOWNLOAD.COPY_LINK')}
                        </button>
                    </div>
                </div>
            </div>

            <div className='step'>
                <div className='step-order'>2</div>
                <div className='step-content'>
                    <p>
                        <Trans
                            i18nKey='DOWNLOAD.web_join_steps.paste_the_link_in'
                            components={{
                                browsers: (
                                    <SupportedBrowserList
                                        browserListDataAtItem={browserListDataAtItem}
                                    />
                                ),
                            }}
                        />
                    </p>
                </div>
            </div>
        </div>
    );
};

UnsupportedJoinSteps.propTypes = {
    trackCopyMeetingEvent: PropTypes.func,
    onSuccessCopyLink: PropTypes.func,
    copyButtonDataAt: PropTypes.string,
    browserListDataAtItem: PropTypes.string,
};
